<app-dialog
  [title]="'Add Season'"
  [actions]="actions"
  (action)="action($event)"
  (close)="close()"
> 
<div class="list">
    <div class="list_item" *ngFor="let season of seasons" [ngClass]="{'list_item--selected': season.isSelected}" (click)="selectSeason(season)">
      <div class="list_checkbox">
          <i class="fas fa-check-circle"></i>
      </div> 
      <div class="list_name">{{season.seasonName}}</div>
        <div class="list_date">{{season.startDate | date:'shortDate'}} - {{season.endDate | date:'shortDate'}}</div>
        <div class="list_percent"><b>Percent Change: </b> {{season.percentageChange}}</div>
    </div>
</div>
 
</app-dialog>